// Cierra la sesión real del HCE (Personal Médico / Director Técnico Q.F.-B.F.,
// cuenta de Medplum) y vuelve a la pantalla de login propia del HCE
// (LandingAcceso.tsx) — pedido explícito del usuario 2026-09-11. Antes no
// existía ningún botón para esto (ver memoria del proyecto "Cambiar de cuenta
// sin logout en el HCE"): la única forma de cambiar de cuenta era borrar
// `@medplum:*` de localStorage a mano desde las DevTools. `medplum.signOut()`
// es lo que limpia esas claves de verdad — replace:true para no dejar la
// ficha/dashboard anterior en el historial (volver atrás no debe reabrir una
// sesión ya cerrada).
//
// MT-047: si la sesión ya venció en el servidor (cierre por inactividad o por el límite absoluto), `signOut` hace un POST a `oauth2/logout` que
// responde 401 y rechaza. Eso no puede dejar a la persona sin llegar al login: `finally` navega SIEMPRE y el rechazo se traga (la sesión ya estaba muerta).
import type { MedplumClient } from '@medplum/core';
import type { NavigateFunction } from 'react-router';
import { cerrarSesionHceAdmin } from './hceAdminSession';

export async function cerrarSesionHce(medplum: MedplumClient, navigate: NavigateFunction): Promise<void> {
  try {
    cerrarSesionHceAdmin();
    await medplum.signOut();
  } catch {
    /* la sesión ya no existía en el servidor: lo local se limpia igual abajo */
  } finally {
    navigate('/login', { replace: true });
  }
}
